import {
  FigjamWidgetMessage,
  // EditorMessage,
} from "../graphpad.types";
import { PLUGIN_ID } from "../constants";

export const postMessageToFigjam = (message: FigjamWidgetMessage) => {
  parent.postMessage({ pluginMessage: message, pluginId: PLUGIN_ID }, "*");
};
